export type SumsubKycStatusForMessage = {
  sumsubReviewAnswer: string | null;
  sumsubReviewRejectType?: string | null;
  sumsubRejectLabels?: string[];
  moderationComment?: string | null;
};

/**
 * Applicant-facing copy for Sumsub rejection on the KYC page.
 */
export function getSumsubRejectionUserMessage(status: SumsubKycStatusForMessage): string {
  const labels = status.sumsubRejectLabels ?? [];
  if (
    status.sumsubReviewAnswer === 'RED' &&
    status.sumsubReviewRejectType === 'RETRY' &&
    labels.includes('UNSATISFACTORY_PHOTOS')
  ) {
    return 'Your identity photos were not accepted (for example, they were unclear or required details were not visible). Please submit your identity details again.';
  }
  const mod = status.moderationComment?.trim();
  if (mod) return mod;
  return 'Identity verification was not successful. Please contact support if you need help.';
}
